import { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from 'jbc-front/components/Button';
import { Balloon } from 'jbc-front/components/presenters/ui/Balloon';
import { useSession } from '@/components/SessionProvider';
import { hasPermission } from '@/utils/permission';

export const AddUser: FC = () => {
  const { user } = useSession();
  const history = useHistory();
  const [isBalloonOpen, setIsBalloonOpen] = useState(false);

  return (
    <>
      <Balloon.Container onClose={() => setIsBalloonOpen(false)}>
        <Button onClick={() => setIsBalloonOpen(isOpen => !isOpen)} widthAuto primary>
          管理者追加
        </Button>
        <Balloon isOpen={isBalloonOpen}>
          {hasPermission(user, 'user_manage_add_lms_user') && (
            <Balloon.Item onClick={() => history.push('/settings/users/invite')}>労務HRの管理者から追加</Balloon.Item>
          )}
          {hasPermission(user, 'user_manage_add_user') && (
            <Balloon.Item onClick={() => history.push('/settings/users/create')}>新しい管理者を追加</Balloon.Item>
          )}
        </Balloon>
      </Balloon.Container>
    </>
  );
};
